import React from 'react';
import { Box } from '@material-ui/core';
import PaymentMethod from './PaymentMethod';
import BillingInfo from './BillingInfo';
import PlanDetails from './PlanDetails';
import InvoiceHistory from './InvoiceHistory';

const Billings: React.FC = () => {
  return (
    <>
      <Box marginBottom={4}>
        <PaymentMethod />
      </Box>
      <Box marginBottom={4}>
        <BillingInfo />
      </Box>
      <Box marginBottom={4}>
        <PlanDetails />
      </Box>
      <InvoiceHistory />
    </>
  );
};

export default Billings;
